import type { IMarket, ISelection } from '@/interface/IMatch';
import { PriceStyle } from '@/interface/enum';
import type { DynamicMarketFragment, DynamicMarketSelectionFragment } from '@/types';

export function formatMarket(market: DynamicMarketFragment): IMarket {
    return {
        id: market.id,
        matchId: market.matchId,
        marketTypeId: market.marketTypeId,
        name: market.name,
        matchStatTypeId: market.matchStatTypeId,
        displayPriority: market.displayPriority,
        isSuspended: market.isSuspended,
        selections: market.selections.map(formatSelection),
    };
}

function formatSelection(selection: DynamicMarketSelectionFragment): ISelection {
    return {
        id: selection.id,
        marketId: selection.marketId,
        isSuspended: selection.isSuspended,
        selectionTypeId: selection.selectionTypeId,
        price: {
            value: selection.price.value,
            priceStyle: PriceStyle.fromOddsApi(selection.price.oddsStyle),
        },
        selectionOrder: selection.selectionOrder,
        name: selection.name,
    };
}
